import React from "react";

import styles from "./marca-propria-alert.module.css";

const MarcaPropriaAlert = ({ id, children }) => (
	<div id={id} className={styles.alertMarcaPropria}>
		{children}
	</div>
);

export default MarcaPropriaAlert;
